var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigitization03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3074_84195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7672 25.6413L21.7812 22.7627C21.0425 22.3362 20.1192 22.8693 20.1192 23.7222V29.4795C20.1192 30.3325 21.0425 30.8656 21.7812 30.4391L26.7672 27.5604C27.5059 27.134 27.5059 26.0678 26.7672 25.6413Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.673828 15.798V8.59593C0.673828 7.00489 1.96362 5.71509 3.55467 5.71509H12.1459C13.1009 5.71509 14.0169 6.0945 14.6921 6.76976L16.9039 8.98154C17.5793 9.65689 18.4951 10.0362 19.4502 10.0362H42.4453C44.0364 10.0362 45.3262 11.326 45.3262 12.9171V15.7979",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1458 5.71509H19.3477C20.3028 5.71509 21.2187 6.0945 21.894 6.76976L24.1058 8.98154C24.7811 9.65689 25.697 10.0362 26.652 10.0362",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2966 5.71509H26.4986C27.4536 5.71509 28.3696 6.0945 29.0449 6.76976L31.2566 8.98154C31.932 9.65689 32.8479 10.0362 33.8029 10.0362",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4453 40.2848H3.55467C1.96362 40.2848 0.673828 38.995 0.673828 37.404V15.7981C0.673828 14.207 1.96362 12.9172 3.55467 12.9172H42.4454C44.0365 12.9172 45.3263 14.207 45.3263 15.7981V37.4041C45.3262 38.995 44.0364 40.2848 42.4453 40.2848Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5161 19.0477C26.968 17.9151 25.0652 17.2383 23 17.2383C17.8292 17.2383 13.6374 21.43 13.6374 26.6009C13.6374 31.7718 17.8292 35.9634 23 35.9634C28.1708 35.9634 32.3626 31.7717 32.3626 26.6008C32.3626 24.5356 31.6858 22.6329 30.5532 21.0847",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3074_84195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitization03);
export default __webpack_public_path__ + "static/media/Digitization03.50044662d5642d560f8531f5feb5da3d.svg";
export { ForwardRef as ReactComponent };